import { JsonProperty } from 'ts-jackson'
import dayjs, { Dayjs } from '@/lib/dayjs'

/**
 * Use this decorator for any Dayjs field
 * It will automatically deserialize string -> Dayjs in Thai timezone
 */
export function DayjsProperty(option?: { path?: string }): PropertyDecorator {
  return JsonProperty({
    ...option,
    deserialize: (value: any): Dayjs | null => {
      if (typeof value !== 'string' || !value) return null

      const d = dayjs.utc(value)
      return d.isValid() ? d.tz('Asia/Bangkok') : null
    },
    serialize: (value: Dayjs | null): any => {
      //check is dayjs
      let _value = value
      if (value && !dayjs.isDayjs(value)) {
        _value = dayjs(value)
      }

      return _value ? _value.toISOString() : null
    },
  }) as unknown as PropertyDecorator
}
